"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.page.prev': 'Prev',
    'dblogs.page.next': 'Next',
    'dblogs.page.info': 'Page',
};
